import isEmpty from 'lodash/isEmpty';

import {
  KarpenterMigrationIntents,
  KarpenterMigrationObjects,
  KarpenterMigrationResponse,
} from '@cast/types';

export const normalizeKarpenterResponse = <
  T extends KarpenterMigrationIntents | KarpenterMigrationResponse
>({
  awsNodeTemplates,
  provisioners,
  ec2NodeClasses,
  nodePools,
}: T): { version: 'alpha' | 'beta'; objects: KarpenterMigrationObjects } => {
  let version: 'alpha' | 'beta' = 'alpha';
  let configurations: KarpenterMigrationObjects['configurations'];

  if (!isEmpty(ec2NodeClasses)) {
    configurations = ec2NodeClasses!;
    version = 'beta';
  } else {
    configurations = awsNodeTemplates!;
  }

  let templates: KarpenterMigrationObjects['templates'];

  if (!isEmpty(nodePools)) {
    templates =
      nodePools?.map(({ ec2NodeClassName, ...rest }) => ({
        ...rest,
        awsNodeTemplateName: ec2NodeClassName,
      })) || [];
    version = 'beta';
  } else {
    templates = provisioners || [];
  }

  return {
    version,
    objects: {
      templates,
      configurations,
    },
  };
};
